import ExternalScriptLoader, { providers } from './external-script-loader'
import { withLogger } from 'lib/logger'

const logger = withLogger('MinuteMedia')

class MinuteMedia extends ExternalScriptLoader {
  scriptUrls = [
    'https://bucket1.mm-syringe.com/prod/configs/a83021e8-1573-63a9-b48a-34fe50ce50e1.js',
    'https://bucket1.mm-syringe.com/prod/injector/injector.1.5.3.js'
  ]
  providerName = providers.minutemedia

  options = { async: true, type: 'text/javascript' }

  init() {
    logger.log('Initalizing')
    !(function (e, t, a, n) {
      ;(e[n] = e[n] || []), e[n].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })
      var m = t.getElementsByTagName(a)[0],
        r = t.createElement(a)
      ;(r.async = !0),
        (r.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-PL4PD49'),
        m.parentNode.insertBefore(r, m)
    })(window.parent, window.parent.document, 'script', 'dataLayer')
    var iframe = window.parent.document.createElement('iframe')
    iframe.src = 'https://www.googletagmanager.com/ns.html?id=GTM-PL4PD49'
    iframe.height = '0'
    iframe.width = '0'
    iframe.style = 'display:none;visibility:hidden'
    window.parent.document.body.appendChild(iframe)
    window.parent['$$mm-analytics'] = window.parent['$$mm-analytics'] || {}
    if (typeof window.parent['$$mm-analytics'].firstEmbed === 'undefined') {
      window.parent['$$mm-analytics'].firstEmbed = Date.now()
    }
    logger.log('Initialized')
  }
}

export default new MinuteMedia()
